import React from "react";
import { Grid, Typography, Switch } from "@mui/material";

const SubmissionFeeSwitch = ({
  formData,
  handleToggleChange,
  theme,
  disabled,
}) => {

  console.log("SubmissionFeeSwitch formData: ", formData);

  return (
    <>
      {/* Allow Buys Toggle Section */}
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography
            variant="body1"
            sx={{ color: "white", fontFamily: "basic-sans" }}
          >
            Charge Submission Fee
          </Typography>
        </Grid>

        <Grid item>
          <Switch
            checked={!!formData.chargeSubmissionFee}
            onChange={handleToggleChange}
            color="default" // Change the default color to prevent MUI's primary styling
            disabled={disabled} // Disable the switch when the prop is true
            sx={{
              "& .MuiSwitch-track": {
                backgroundColor: formData.chargeSubmissionFee
                  ? theme.colors.green
                  : theme.colors.red,
                opacity: 1, // Ensure the track color is strong
              },
              "& .MuiSwitch-thumb": {
                backgroundColor: formData.chargeSubmissionFee
                  ? theme.colors.green
                  : theme.colors.red,
              },
              "& .MuiSwitch-switchBase.Mui-checked": {
                "& + .MuiSwitch-track": {
                  backgroundColor: theme.colors.green,
                  opacity: 0.5,
                },
              },
              "& .MuiSwitch-switchBase": {
                "&:not(.Mui-checked) + .MuiSwitch-track": {
                  backgroundColor: theme.colors.red,
                  opacity: 0.5,
                },
              },
            }}
          />
        </Grid>

        <Grid item>
          <Typography
            variant="body2"
            sx={{
              color: formData.chargeSubmissionFee
                ? theme.colors.green
                : theme.colors.red,
              fontFamily: "basic-sans",
            }}
          >
            {formData.chargeSubmissionFee ? "ON" : "OFF"}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default SubmissionFeeSwitch;
